import {
  generateKeypair,
  getStoredKeypair,
  hasStoredKey as hasKeyInStorage,
  signEventWithKey,
  decodeNsec,
  encodeNsec,
  type NostrEvent,
  type SignedNostrEvent,
} from './nostr-keygen';

export function hasNostr(): boolean {
  return typeof window !== 'undefined' && window.nostr !== undefined;
}

export { hasKeyInStorage as hasStoredKey };

export async function login(): Promise<string> {
  if (!window.nostr) throw new Error('No NIP-07 extension found. Install Alby or nos2x.');
  return await window.nostr.getPublicKey();
}

export async function loginWithGeneratedKey(): Promise<{ pubkey: string; nsec: string; isNew: boolean }> {
  let keypair = getStoredKeypair();
  let isNew = false;
  if (!keypair) {
    keypair = generateKeypair();
    isNew = true;
  }
  return { pubkey: keypair.publicKey, nsec: encodeNsec(keypair.privateKey), isNew };
}

export async function loginWithNsec(nsec: string): Promise<string> {
  const hexPrivkey = decodeNsec(nsec);
  localStorage.setItem('nostr-privkey', hexPrivkey);
  const keypair = getStoredKeypair();
  if (!keypair) throw new Error('Failed to load key after storing');
  return keypair.publicKey;
}

export async function signEvent(event: {
  kind: number;
  created_at: number;
  tags: string[][];
  content: string;
}): Promise<SignedNostrEvent> {
  const storedKeypair = getStoredKeypair();
  if (storedKeypair) {
    return signEventWithKey(event as NostrEvent, storedKeypair.privateKey);
  }
  if (window.nostr) {
    return await window.nostr.signEvent(event);
  }
  throw new Error('No NIP-07 extension and no stored key. Please log in first.');
}
